var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "navbar__desktop" },
    [
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.subnav
          ? _c("div", {
              staticClass: "navbar__desktop__overlay",
              on: { click: _vm.hideSearch },
            })
          : _vm._e(),
      ]),
      _c("div", { staticClass: "navbar__desktop__wrapper" }, [
        _c("div", { staticClass: "container container--nav" }, [
          _c(
            "div",
            { staticClass: "navbar__left" },
            [
              _vm._t("logo"),
              _c("div", { staticClass: "navbar__links" }, [
                _c(
                  "ul",
                  { staticClass: "navbar__linklist" },
                  _vm._l(_vm.links, function (link) {
                    return _c(
                      "li",
                      {
                        key: link.title,
                        staticClass:
                          "navbar__linklist__link navbar__linklist__link--text",
                      },
                      [
                        link.children
                          ? _c(
                              "a",
                              {
                                staticClass: "navbar__link",
                                attrs: { href: _vm.cleanURL(link.url) },
                                on: {
                                  mouseenter: function ($event) {
                                    return _vm.showSubnav(link.handle)
                                  },
                                  focus: function ($event) {
                                    return _vm.showSubnav(link.handle)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(link.title))]
                            )
                          : _c(
                              "a",
                              {
                                staticClass: "navbar__link",
                                attrs: { href: _vm.cleanURL(link.url) },
                                on: {
                                  mouseenter: _vm.hideSubnav,
                                  focus: _vm.hideSubnav,
                                },
                              },
                              [_vm._v(_vm._s(link.title))]
                            ),
                        link.children
                          ? _c("transition", { attrs: { name: "fade" } }, [
                              _vm.subnav && _vm.subnav === link.handle
                                ? _c(
                                    "div",
                                    {
                                      key: link.handle,
                                      staticClass: "navbar__subnav",
                                      on: { mouseleave: _vm.hideSubnav },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "container navbar__subnav__container",
                                        },
                                        _vm._l(
                                          link.children,
                                          function (childLink) {
                                            return _c(
                                              "a",
                                              {
                                                key: childLink.title,
                                                staticClass:
                                                  "navbar__subnav__link",
                                                attrs: {
                                                  href: _vm.cleanURL(
                                                    childLink.url
                                                  ),
                                                },
                                              },
                                              [_vm._v(_vm._s(childLink.title))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "navbar__right",
              class: { "search-open": _vm.subnav && _vm.subnav === "search" },
            },
            [
              _c(
                "div",
                { staticClass: "navbar__search" },
                [
                  _vm.subnav && _vm.subnav === "search"
                    ? _c("icon-button", {
                        staticClass: "navbar-search__submit",
                        attrs: {
                          icon: "close",
                          width: "22px",
                          height: "20px",
                          label: "Close Search",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.hideSubnav()
                          },
                        },
                      })
                    : _c("icon-button", {
                        staticClass: "navbar-search__submit",
                        attrs: {
                          icon: _vm.getSearchIcon,
                          width: "22px",
                          height: "20px",
                          label: "Search",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showSubnav("search")
                          },
                        },
                        nativeOn: {
                          mouseover: function ($event) {
                            _vm.searchHighlighted = true
                          },
                          mouseleave: function ($event) {
                            _vm.searchHighlighted = false
                          },
                        },
                      }),
                ],
                1
              ),
              _c("ul", { staticClass: "navbar__linklist" }, [
                _c(
                  "li",
                  { staticClass: "navbar__linklist__link" },
                  [
                    _c("icon-link", {
                      staticClass: "navbar__linklist__link--user",
                      attrs: {
                        icon: _vm.getUserIcon,
                        width: "17px",
                        height: "22px",
                        href: this.userLink,
                        label: _vm.userLabel,
                      },
                      nativeOn: {
                        mouseover: function ($event) {
                          _vm.userHighlighted = true
                        },
                        mouseleave: function ($event) {
                          _vm.userHighlighted = false
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "li",
                  { staticClass: "navbar__linklist__link" },
                  [_c("navbar-cart")],
                  1
                ),
              ]),
            ]
          ),
          _vm.subnav && _vm.subnav === "search"
            ? _c(
                "div",
                {
                  staticClass: "navbar__subnav",
                  on: {
                    mouseenter: function ($event) {
                      _vm.overSearchResults = true
                    },
                    mouseleave: function ($event) {
                      _vm.overSearchResults = false
                    },
                  },
                },
                [
                  _c("navbar-search", {
                    ref: "searchBox",
                    attrs: { suggestedSearches: _vm.suggestedSearches },
                    on: {
                      "open-results": function ($event) {
                        return _vm.showSubnav("search")
                      },
                      "close-results": _vm.onCloseResults,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }